import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import {FaIconLibrary} from '@fortawesome/angular-fontawesome';
import * as fas from "@fortawesome/free-solid-svg-icons";
import { UserStore } from './stores/users.store';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'LTI Demo';

  readonly user$ = inject(UserStore) ;
  

  constructor(library: FaIconLibrary) {

    this.user$.load();

    library.addIcons(
      fas.faCaretDown,
      fas.faRotateLeft,

      fas.faCheck,

      fas.faCircle,
      fas.faCircleQuestion,
      fas.faCircleMinus,
      fas.faCircleArrowUp,
      fas.faCircleChevronLeft,
      fas.faCirclePlus,
      fas.faCircleNotch,
      fas.faCircleHalfStroke,
      fas.faTimesCircle,

      fas.faFaceMeh,
      fas.faFaceSmile,
      fas.faFaceGrin,

      fas.faEye,
      fas.faSearch,
      fas.faShare,
      fas.faCamera,
      fas.faTrash,
      fas.faCopy,
      fas.faLink,
      fas.faBars,
      fas.faCloudArrowDown,
      fas.faArrowUpRightFromSquare,

      fas.faCog,
      fas.faComment,
      fas.faRotate,
      fas.faCircleInfo,

      fas.faListOl,
      fas.faList,
      fas.faBold,
      fas.faItalic,
      fas.faPen
    ) ;

  }
}
